export const TitlesDictionary = {
  tourist_terms_of_use: 'Termos de uso do viajante',
  company_terms_of_use: 'Termos de uso',
  privacy_policy: 'Política de privacidade e cookies',
  cookies_policy: 'Política de cookies'
}
